// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".group-wrapper[data-v-8015bb56] .active-child{background-color:hsla(0,0%,100%,.5)}", ""]);
// Exports
module.exports = exports;
